import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link, Redirect, Switch, Route } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';

import { NavItem } from 'react-bootstrap';
import RequiredTVCollectorMappingSetup from '../../pages/TruVoiceCollectorsPage/RequiredTVCollectorMappingSetup';
import InnerPage from './TruVoiceTagsInnerPage';
import { fetchAllFilters } from '../../FilterActions';
import ProgressBar from '../../../../components/progress-bar';

class TruVoiceTagsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loaded: false,
      errors: null,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    this.setState({ loading: true, loaded: false, errors: null });
    this.props.dispatch(fetchAllFilters())
      .then(
        () => {
          this.setState({ loading: false, loaded: true });
        },
        (errors) => {
          this.setState({
            loading: false, loaded: false, errors: errors.data?.message || errors,
          });
        },
      );
  }
  
  renderInstruction() {
    const url = process.env.REACT_APP_TRUVOICE_URL || null;
    const tagAnchor = url ? (
      <a href={url} target="_blank" rel="noreferrer">TruVoice tags</a>
    ) : (<span>TruVoice tags</span>);
     
    return (
      <div className="well">
        <p>
          The table below contains the fields you have <Link to="/setup/sync-settings">enabled</Link> in TruSales that can be used to tag opportunities when they are submitted to TruVoice for feedback requests.
          The values of the fields enabled in this table will be used as {tagAnchor} for all opportunities/accounts submitted for feedback requests.
        </p>
        <p>
          The following field types can be used to as {tagAnchor}: <code>picklist</code>, <code>multipicklist</code>, <code>string</code> and <code>reference</code> fields.
        </p>
        <p>
          Use the <strong>Apply Tag</strong> option in the Actions menu to apply a field&rsquo;s values as {tagAnchor} to previously submitted opportunities.
        </p>
        <p>
          These tags can then be used to filter the feedback in TruVoice and allow deeper analysis of your buyer feedback.
        </p>
      </div>
    );
  }

  render() {
    const { location: { pathname } } = this.props;
    const { loading } = this.state;
    const comps = [
      {
        uri: 'opportunities',
        source: 'opportunity',
        label: 'Opportunity Tags',
      },
      {
        uri: 'accounts',
        source: 'account',
        label: 'Account Tags',
      },
      {
        uri: 'contacts',
        source: 'contact',
        label: 'Contact Tags',
      },
    ];
    return (
      <div className="container">
        <Helmet title="TruVoice Tags" />
        {this.renderInstruction()}
        <p />
        {loading && <ProgressBar />}
        {!loading && 
          <div>
            {comps.length > 1 &&
              <div>
                <ul className="nav nav-tabs">
                  {comps.map(comp => (
                    <LinkContainer key={comp.uri} to={`/setup/truvoice-tags/${comp.uri}`}>
                      <NavItem>{comp.label}</NavItem>
                    </LinkContainer>
                  ))}
                </ul>
                <p />
              </div>
            }
            {comps.length > 0 && pathname === '/setup/truvoice-tags' && <Redirect to={`/setup/truvoice-tags/${comps[0].uri}`} />}
          </div>
        }
        <RequiredTVCollectorMappingSetup allowDisabled types={['decision', 'experience']}>
          {(validCollectors, validAvailableCollectors) => (
            <div>
              {!loading && 
                <div>
                  <Switch>
                    {comps.map((comp) => {
                      return (
                        <Route
                          key={comp.uri}
                          path={`/setup/truvoice-tags/${comp.uri}`}
                          render={(props) => {
                            return (<InnerPage collectors={validAvailableCollectors} source={comp.source} {...props} />);
                          }}
                        />
                      );
                    })}
                  </Switch>
                </div>
              }
            </div>
          )}
        </RequiredTVCollectorMappingSetup>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
  };
}

TruVoiceTagsPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({}).isRequired,
};

TruVoiceTagsPage.contextTypes = {
  router: PropTypes.shape({}),
  addNotification: PropTypes.func.isRequired,
};


export default withRouter(connect(mapStateToProps)(TruVoiceTagsPage));
